/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getUsageAudioResultSchema = z.object({
  audioUrl: z.string(),
});

export type IGetUsageAudioResult = z.infer<typeof getUsageAudioResultSchema>;

export const getUsageAudioResponseSchema = createApiResponseSchema(
  getUsageAudioResultSchema,
) as z.ZodSchema<IAPI<IGetUsageAudioResult>>;

export type IGetUsageAudioResponse = IAPI<IGetUsageAudioResult>;
